<template>
  <div>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>

    <!-- <audio id="audio" loop autoplay :src="defaultMusic"></audio> -->

    <div class="tabbarSpace"></div>
    <van-tabbar
      fixed
      active-color="#24a378"
      v-model="active"
      @change="onChange"
      :z-index="99"
      route
    >
      <van-tabbar-item
        :to="{ path: '/MemorialHall', query: { id: id } }"
        :replace="true"
      >
        <span>主页</span>
        <i class="iconfont iconnav_home1" slot="icon"></i>
      </van-tabbar-item>
      <van-tabbar-item
        :to="{ path: '/Life', query: { id: id } }"
        :replace="true"
      >
        <span>生平</span>
        <i class="iconfont iconnav_obituary" slot="icon"></i>
      </van-tabbar-item>
      <van-tabbar-item
        :to="{ path: '/Photos', query: { id: id } }"
        :replace="true"
      >
        <span>影像</span>
        <i class="iconfont iconsmilingface" slot="icon"></i>
      </van-tabbar-item>
      <van-tabbar-item
        :to="{ path: '/Memory', query: { id: id } }"
        :replace="true"
      >
        <span>追忆</span>
        <i class="iconfont iconnav_recollection" slot="icon"></i>
      </van-tabbar-item>
      <van-tabbar-item
        :to="{ path: '/Mailbox', query: { id: id } }"
        :replace="true"
      >
        <span>信箱</span>
        <i
          class="iconfont iconnav_mailbox"
          slot="icon"
          style="font-size: 16px !important;"
        ></i>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
/*import Music from '@/components/music'*/
import auth from "../../tools/auth.js";

export default {
  data() {
    return {
      active: 0,
      nowPath: "",
      songReady: false,
      id: 0,
      defaultMusic: "http://www.jq22.com/demo/vuekgbfq202003082021/xs.mp3",
    };
  },
  components: {},
  watch: {
    isPlaying() {
      console.log("音乐状态改变");
      let oAudio = document.querySelector("#audio");
      this.$nextTick(() => {
        this.$store.state.isPlaying ? oAudio.play() : oAudio.pause();
      });
    },
  },
  computed: {
    isPlaying() {
      return this.$store.state.isPlaying;
    },
  },
  //被创建
  mounted: function() {
    var that = this;
    this.$store.state.isPlaying = true;
    let oAudio = document.querySelector("#audio");
    if (oAudio && this.$store.state.isPlaying) {
      oAudio.play();
    } else {
      oAudio.pause();
    }
    oAudio.onpause = function(a) {
      that.$store.commit("setPlayControlurl", {
        id: that.id,
        url: oAudio.currentSrc,
        time: oAudio.currentTime,
      });
    };
    oAudio.onplay = function(a) {
      var temp = that.$store.state.playControl[that.id];
      if (oAudio.currentSrc == temp.url) {
        oAudio.currentTime = temp.time == undefined ? 0 : temp.time;
      }
    };
    //this.musicList.push(this.defaultMusic);
    //console.log(this.musicList);
  },
  methods: {
    onChange(index) {
      // console.log("~~~~~~~~~~~~~~~~~~~~~~")
      // console.log(index);
      // console.log("~~~~~~~~~~~~~~~~~~~~~~")
    },
    init() {
      var that = this;
      this.$store
        .dispatch({
          type: "GetMusicInfoManageDefaultMusic",
          MemorialHallId: that.id,
        })
        .then(
          (res) => {
            that.defaultMusic = res.DefaultMusic;
            let oAudio = document.querySelector("#audio");
            if (oAudio.src != that.defaultMusic) {
              oAudio.src = that.defaultMusic;
            }

            if (this.$store.state.playControl[this.id] == undefined) {
              this.$store.commit("setPlayControl", { id: this.id, play: true });
            }

            this.$store.state.isPlaying = this.$store.state.playControl[
              that.id
            ].play;
            this.$store.state.isPlaying ? oAudio.play() : oAudio.pause();
            // this.$store.state.isPlaying = true;
            // oAudio.play();
          },
          (err) => {}
        );
    },
  },
  beforeRouteEnter(to, from, next) {
    next();
  },
  beforeRouteLeave(to, from, next) {
    let oAudio = document.querySelector("#audio");
    if (
      to.name != "Worship" &&
      to.name != "Cemetery" &&
      to.name != "MemoryDetails" &&
      to.name != "MailboxAdd" &&
      to.name != "ImageDetails" &&
      to.name != "ImageAdd" &&
      to.name != "VideoAdd" &&
      to.name != "MemoryAdd" &&
      to.name != "TemplateList" &&
      to.name != "HallInfoEdit" &&
      to.name != "MemorialHallSet" &&
      to.name != "BookingGoodsList"
    ) {
      if (to.name != "VideoDetails") {
        this.$store.state.isPlaying = false;
      }
      if (from.name != "VideoDetails") {
        oAudio.pause();
      }
    }
    if (to.name != "VideoDetails") {
      if (this.$store.state.isPlaying) {
        oAudio.play();
      } else {
        oAudio.pause();
      }
    }
    next();
  },
  activated: function() {
    var that = this;
    var id = this.$route.query.id;
    this.id = id;
    auth.IsPublic(this, id).then((res) => {
      // console.log(res);
      if (!res) {
        that.$router.replace({
          name: "NotPublic"
        });
      } else {
        that.init();
      }
    });
    // this.init();
    // let oAudio = document.querySelector("#audio");
    // if (oAudio && this.$store.state.isPlaying) {
    //   oAudio.play();
    // } else {
    //   oAudio.pause();
    // }
  },
  created() {
    var id = this.$route.query.id;
    this.id = id;

    // this.init();
  },
};
</script>

<style scoped></style>
